import { render, staticRenderFns } from "./Mini.vue?vue&type=template&id=8fb8fe9c&scoped=true"
import script from "./Mini.vue?vue&type=script&lang=js"
export * from "./Mini.vue?vue&type=script&lang=js"
import style0 from "./Mini.vue?vue&type=style&index=0&id=8fb8fe9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb8fe9c",
  null
  
)

export default component.exports